import React, { Component } from 'react';
import {
   Card, CardBody, Col, Table, Badge, Button, UncontrolledTooltip,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import swal from 'sweetalert';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';

import CommonService from '../../../services/CommonService';
import ConfirmStockModal from './ConfirmStockModal';
import ReturnModal from './ReturnModal';
import global from '../../../global';

class StocksDistribution extends Component {
   static propTypes = {
      itemID: PropTypes.string.isRequired,
   };

   constructor(props) {
      super(props);
      const { itemID } = this.props;
      this.state = {
         list: [],
         inventoryInfo: {
            name: 'Product Name',
            total_beginning: '0',
            total_receive: '0',
            total_receive_pending: '0',
            total_out: '0',
            return: '0',
            new_balance: '0',
         },
         modal: false,
         formdata: {
            inventoryId: '',
            actualQuantity: '',
            note: '',
            status: 0,
            quantity: 0,
         },
         stockStatus: '',
         errorMsg: '',
      };
      this.isLoading = false;
      this.toggleModal = this.toggleModal.bind(this);
      this.returnStockToggle = this.returnStockToggle.bind(this);
      this.inventory_control_id = itemID;
      this.executeModal = '';
      this.userdata = JSON.parse(localStorage.getItem('userData'));
   }

   componentDidMount() {
      this.isLoading = true;
      this.onLoadStocks();
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   handleChange = (e, fieldName = '') => {
      if (fieldName === 'deliver') {
         if (e) {
           this.setState(prevState => ({
             formdata: { ...prevState.formdata, deliverVal: e.value, deliverTxt: e.label },
           }));
         } else {
           this.setState(prevState => ({
             formdata: { ...prevState.formdata, deliverVal: undefined, deliverTxt: undefined },
           }));
         }
      } else if (fieldName === 'transaction') {
         this.setState(prevState => ({
           formdata: { ...prevState.formdata, transactionType: e },
         }));
      } else if (fieldName === 'number') {
         const { name, value } = e.target;
         this.setState(prevState => ({
           formdata: { ...prevState.formdata, [name]: value.replace(/[^0-9.]/g, '') },
         }));
      } else {
         const { name, value } = e.target;
         this.setState(prevState => ({
           formdata: { ...prevState.formdata, [name]: value },
         }));
      }
   }

   onLoadStocks = async () => {
      try {
         const response = await CommonService.getRows(`stockdistributionentries/inventoryid/${this.inventory_control_id}`);
         if (this.isLoading && response) {
            const { info, lists } = response;
            this.setState({
               list: lists,
               locationid: info.location_id,
               inventoryInfo: {
                  name: info.product_name,
                  total_beginning: info.stock_beginning,
                  total_receive: info.stock_receive,
                  total_receive_pending: info.stock_receive_pending,
                  total_out: info.stock_out,
                  return: info.stock_return,
                  new_balance: info.stock_balance,
                },
            });
         }
      } catch (err) {
         console.log('Error: ', err.message);
      }
   }

   confirmStock(e, inventoryId, status, quantity = 0) {
      e.preventDefault();
      this.executeModal = 'confirmation';
      this.toggleModal();
      this.setState({
         formdata: {
            actualQuantity: quantity,
            note: '',
            inventoryId,
            status,
            quantity,
         },
         stockStatus: status.toString(),
      });
      // submit form
      this.handleSubmit = (ev) => { this.submitConfirmation(ev); };
   }

   async submitConfirmation(e) {
      e.preventDefault();
      const {
         formdata, locationid,
      } = this.state;
      formdata.locationId = parseInt(locationid, 10) > 0 ? locationid : this.userdata ? this.userdata.location_id : 0;

      if ((formdata.status === 1 && formdata.actualQuantity) || (formdata.status === 2 && formdata.note)) {
         this.setState({ errorMsg: '' });
         const result = await CommonService.updateData('updatestockstatus', formdata);
         if (result === true) {
            window.location.reload();
            swal('', 'Successfully updated information!', 'success');
         } else {
            this.setState({ modal: false });
            swal('', 'Failed to update information', 'warning');
         }
      } else {
         this.setState({ errorMsg: 'Required fields are empty.' });
      }
   }

   returnStockToggle(e) {
      e.preventDefault();
      const { inventoryInfo } = this.state;
      this.executeModal = 'return';
      this.toggleModal();
      this.setState({
         formdata: {
           added_by: this.userdata.user_id,
           deliverTxt: '',
           deliverVal: '',
           currentStock: inventoryInfo.new_balance,
           perKilo: '',
           reason: '',
           transactionType: '1',
         },
       });
      // submit form
      this.handleSubmit = (ev) => { this.returnStockSubmit(ev); };
   }

   async returnStockSubmit(e) {
      e.preventDefault();
      const { formdata, inventoryInfo } = this.state;
      formdata.control_id = this.inventory_control_id;

      if (formdata.perKilo && formdata.deliverVal && formdata.transactionType && formdata.reason) {
         if (parseFloat(formdata.perKilo, 10) <= parseFloat(inventoryInfo.new_balance, 10)) {
            this.setState({ errorMsg: '' });
            const result = await CommonService.insertData('returnstock', formdata);
            if (result) {
               if (result === true) {
                  inventoryInfo.new_balance = parseFloat(inventoryInfo.new_balance, 10) - parseFloat(formdata.perKilo, 10);
                  this.setState({ errorMsg: '', modal: false });
               } else {
                  this.setState({ errorMsg: result });
               }
            } else {
               this.setState({ modal: false });
               swal('', 'Something went wrong!', 'error');
            }
         } else {
            this.setState({ errorMsg: 'Enter quantity less than or equal to your current stock.' });
         }
      } else {
         this.setState({ errorMsg: 'Required fields are empty.' });
      }
   }

   toggleModal() {
      this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         list, inventoryInfo, formdata, modal, stockStatus, errorMsg, locationid,
      } = this.state;
      const { movementStatus, iceType } = global;
      const backLink = this.userdata.type === '1' ? `/inventory/retailstore/dashboard/${locationid}` : '/stocks/list';

      if (this.inventory_control_id == null) {
         return (<Redirect to="/login" />);
      }

      return (
         <Col md={12}>
            {
               this.executeModal === 'confirmation' ? (
                  <ConfirmStockModal
                     modal={modal}
                     toggle={this.toggleModal}
                     handleChange={this.handleChange}
                     postValue={formdata}
                     errorMsg={errorMsg}
                     stockStatus={stockStatus}
                     handleSubmit={this.handleSubmit}
                  />
               ) : this.executeModal === 'return' ? (
                  <ReturnModal
                     modal={modal}
                     toggle={this.toggleModal}
                     handleChange={this.handleChange}
                     postValue={formdata}
                     errorMsg={errorMsg}
                     stockStatus={stockStatus}
                     handleSubmit={this.handleSubmit}
                  />
               ) : ''
            }
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                     <h5 className="bold-text">{inventoryInfo.name}</h5>
                     <div className="panel__btns">
                        {
                           parseFloat(inventoryInfo.new_balance, 10) > 0 && (
                              <Button className="rounded text-white btn-awesome" onClick={this.returnStockToggle} size="sm" outline>
                                 <i className="fa fa-undo" />
                                 <span>Return Stock</span>
                              </Button>
                           )
                        }
                        <Link className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" to={backLink}>
                           <i className="fa fa-arrow-left" />
                           <span>Back</span>
                        </Link>
                     </div>
                  </div>
                  <div className="panel__content">
                     <div className="stock-box__container stock-6 stock-sm text-left">
                        <div className="stock-box outline stock-aqua">
                           <div className="stock-box__icon"><i className="fa fa-box" /></div>
                           <h3 className="stock-box__num">{inventoryInfo.total_beginning > 0 ? `${inventoryInfo.total_beginning} kgs.` : 0}</h3>
                           <h4 className="stock-box__text">Beginning Stock</h4>
                        </div>
                        <div className="stock-box outline stock-blue">
                           <div className="stock-box__icon"><i className="fa fa-dolly-flatbed" /></div>
                           <h3 className="stock-box__num">{inventoryInfo.total_receive > 0 ? `${inventoryInfo.total_receive} kgs.` : 0}</h3>
                           <h4 className="stock-box__text">Total Received</h4>
                        </div>
                        <div className="stock-box outline stock-orange">
                           <div className="stock-box__icon"><i className="fa fa-truck-loading" /></div>
                           <h3 className="stock-box__num">{inventoryInfo.total_receive_pending > 0 ? `${inventoryInfo.total_receive_pending} kgs.` : 0}</h3>
                           <h4 className="stock-box__text">Total Stock Pending</h4>
                        </div>
                        <div className="stock-box outline stock-pink">
                           <div className="stock-box__icon"><i className="fa fa-dolly" /></div>
                           <h3 className="stock-box__num">{inventoryInfo.total_out > 0 ? `${inventoryInfo.total_out} kgs.` : 0}</h3>
                           <h4 className="stock-box__text">Total Out</h4>
                        </div>
                        <div className="stock-box outline stock-green">
                           <div className="stock-box__icon"><i className="fa fa-truck-loading" /></div>
                           <h3 className="stock-box__num">{inventoryInfo.return > 0 ? `${inventoryInfo.return} kgs.` : 0}</h3>
                           <h4 className="stock-box__text">Return</h4>
                        </div>
                        <div className="stock-box outline stock-red">
                           <div className="stock-box__icon"><i className="fa fa-boxes" /></div>
                           <h3 className="stock-box__num">{inventoryInfo.new_balance > 0 ? `${inventoryInfo.new_balance} kgs.` : 0}</h3>
                           <h4 className="stock-box__text">New Balance</h4>
                        </div>
                     </div>
                  </div>
                  <div className="panel__content">
                     {/* Table */}
                     <Table responsive striped>
                        <thead>
                           <tr>
                              <th width="20%">From</th>
                              <th className="text-center">Quantity</th>
                              <th className="text-center">Actual Quantity</th>
                              <th className="text-center">Remaining Quantity</th>
                              <th className="text-center">Type</th>
                              <th className="text-center">Status</th>
                              <th className="text-center">Note</th>
                              <th className="text-center">Date</th>
                              <th className="text-center">Action</th>
                           </tr>
                        </thead>
                        <tbody>
                        {
                           list !== false || list.length > 0 ? list.map((item, i) => {
                              item.status = parseInt(item.status, 10);
                              let statusColor = 'success';
                              const inventoryId = item.inventory_control_entry_id;

                              if (item.status === 0) {
                                 statusColor = 'warning';
                              } else if (item.status === 2 || item.status === 3) {
                                 statusColor = 'danger';
                              }

                              return (
                                 <tr key={`stock_dist${inventoryId}`} className="text-center">
                                    <td className="text-left">{item.location_name ? item.location_name : item.customer_name}</td>
                                    <td>{item.quantity ? `${item.quantity} kgs.` : '-'}</td>
                                    <td>{item.actual_quantity ? `${item.actual_quantity} kgs.` : '-'}</td>
                                    <td>{item.remaining_quantity ? `${item.remaining_quantity} kgs.` : '-'}</td>
                                    <td>{iceType[item.type]}</td>
                                    <td><Badge color={statusColor}>{movementStatus[item.status]}</Badge></td>
                                    <td className="white-space-pre-wrap text-center">{item.note ? item.note : '-'}</td>
                                    <td>{item.date_added}</td>
                                    <td>
                                       {
                                          item.status === 0 && item.flag === '0' ? (
                                             <span>
                                                {/* Approve */}
                                                <Button color="success" className="btn-xs" title="Approve" onClick={e => this.confirmStock(e, inventoryId, 1, item.quantity)} id={`approvebtn${i + 1}`} outline><span className="fa fa-check" /></Button>
                                                <UncontrolledTooltip placement="bottom" target={`approvebtn${i + 1}`}>Approve</UncontrolledTooltip>
                                                {/* Deny */}
                                                <Button color="danger" className="btn-xs" title="Deny" onClick={e => this.confirmStock(e, inventoryId, 2, item.quantity)} id={`denybtn${i + 1}`} outline><span className="fa fa-times" /></Button>
                                                <UncontrolledTooltip placement="bottom" target={`denybtn${i + 1}`}>Deny</UncontrolledTooltip>
                                             </span>
                                          ) : '--'
                                       }
                                    </td>
                                 </tr>
                              );
                           }) : (
                              <tr className="text-center">
                                 <td colSpan="8">No data available..</td>
                              </tr>
                           )
                        }
                        </tbody>
                     </Table>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(StocksDistribution);
